export default __webpack_public_path__ + "static/media/writingHand.29f87470.webp";